import api from './baseApi';

export const addEmployee = async (employee: EmployeeToAdd) => {
  try {
    const response = await api.post('/employee', employee);
    return response;
  } catch (error: any) {
    throw new Error(error.response.data.message);
  }
};
export const getEmployee = async (id: string) => {
  try {
    const response = await api.get(`/employee/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching client:', error);
  }
};

export const getEmployees = async ({
  page,
  perPage,
  searchTerm,
}: {
  page?: number;
  perPage?: number;
  searchTerm?: string;
}) => {
  try {
    // Build query parameters only when the values are provided
    const queryParams = new URLSearchParams();

    if (page) queryParams.append('page', String(page));
    if (perPage) queryParams.append('perPage', String(perPage));
    if (searchTerm) queryParams.append('fullname', searchTerm);

    const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
    const response = await api.get(`/employee${query}`);

    return response.data;
  } catch (error) {
    console.error('Error fetching employees:', error);
    return [];
  }
};
